import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS} from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { ModalModule } from "ngx-bootstrap/modal";
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { ManageGamesRoutingModule } from "./manage-games-routing.module";
import { ApiInterceptor } from "../../shared/services/interceptor/api.interceptor";
import { JwtParserService } from "../../shared/services/jwt-parser.service";
import { AuthGuard } from "../../shared/services/auth.guard";
import { TooltipModalComponent } from "../../shared/components/tooltip-modal/tooltip-modal.component";
import { ModalService } from "../../shared/services/modal.service";
import { GameService } from "../../shared/services/game/game.service";
import { SharedModule } from "../../shared/shared.module";
import { GameGridComponent } from './game-components/game-grid/game-grid.component';
import { PrizeRedeemComponent } from './game-components/prize-redeem/prize-redeem.component';
import { GameCardComponent } from './game-components/game-card/game-card.component';
import { PrizeDetailsComponent } from './game-components/prize-details/prize-details.component';
import { GameSummaryComponent } from './game-components/game-summary/game-summary.component';
import { JumpListComponent } from './game-components/jump-list/jump-list.component';
import { JumpListItemComponent } from './game-components/jump-list-item/jump-list-item.component';
import { ManageGamesComponent } from './manage-games/manage-games.component';
import { MyPrizeListComponent } from './game-components/my-prize-list/my-prize-list.component';
import { OptInComponent } from './game-components/opt-in/opt-in.component';
import { PrizeGridComponent } from './game-components/prize-grid/prize-grid.component';
import { PrizeCardComponent } from './game-components/prize-card/prize-card.component';
import { TokenActivityComponent } from './game-components/token-activity/token-activity.component';
import { GameDisclaimerComponent } from './game-components/game-disclaimer/game-disclaimer.component';
import { CloseOnEscDirective } from '../../shared/directives/esc-tooltip.directive';
import { BonusPathComponent } from './bonus-path/bonus-path.component';
import { DealsGridModule } from 'abs-ngx-library/src/lib/deals-grid';


@NgModule({
  declarations: [
    GameGridComponent,
    PrizeRedeemComponent,
    GameCardComponent,
    PrizeDetailsComponent,
    GameSummaryComponent,
    JumpListComponent,
    JumpListItemComponent,
    ManageGamesComponent,
    MyPrizeListComponent,
    OptInComponent,
    PrizeGridComponent,
    PrizeCardComponent,
    TokenActivityComponent,
    GameDisclaimerComponent,
    CloseOnEscDirective,
    BonusPathComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ManageGamesRoutingModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    SharedModule,
    DealsGridModule
  ],
  exports: [],
  providers: [JwtParserService, AuthGuard, TooltipModalComponent, {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiInterceptor,
    multi: true
  },
    ModalService,
    GameService],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class ManageGamesModule { }
